import api from './api';

const ENDPOINT = 'campaign-points';

const CampaignPointService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  getByCampaign: (campaignId, params = null) =>
    api.get(`${ENDPOINT}/get-by-campaign`, {
      params: {
        ...params,
        campaignId,
      },
    }),
  import: (campaignId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    return api.post(`${ENDPOINT}/${campaignId}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    });
  },
};

export default CampaignPointService;
